var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFunding = function SvgFunding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m9.033 12.928-1.961-1.961a1.356 1.356 0 0 1 0-1.934l1.961-1.961c.54-.54 1.393-.54 1.934 0l1.961 1.961c.54.54.54 1.393 0 1.934l-1.961 1.961c-.54.54-1.393.54-1.934 0m.884-.884-1.961-1.961c-.032-.032-.04-.061-.04-.083s.008-.05.04-.083l1.961-1.961c.032-.032.061-.04.083-.04s.05.008.083.04l1.961 1.961c.032.032.04.061.04.083s-.008.05-.04.083l-1.961 1.961c-.032.032-.061.04-.083.04s-.05-.008-.083-.04",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 1.875a8.125 8.125 0 1 0 0 16.25 8.125 8.125 0 0 0 0-16.25M3.125 10a6.875 6.875 0 1 1 13.75 0 6.875 6.875 0 0 1-13.75 0",
    clipRule: "evenodd"
  })));
};
export default SvgFunding;